import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import HeaderSubVendor from '../HeaderSubVendor';
import SubVendorVechileTab from './SubVendorVechileTab';
import { getMatrixVehicle, getMoreVehicle, getVehicle, patchUpdateVehicle } from 'redux/actions/UserVehicle';
import { editSubVehicleDialogData } from './SubVendorVechileData';
import { vehicleImage} from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { vehicleInfo as generateVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { amenitiesVehicle as aminitiesVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';

function VechileSubVendorView() {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role')
  const {state} = useLocation();
  const id = state?.vehicleId;
  const name = state?.name;
  const cityLocation = state?.cityLocation
  const subVendorName = state?.subVendorName
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get("vehicleId");
  // const name = searchParams.get("name");
  const [value, setValue] = useState('1');
  const vehicleData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);
  const dialogData = editSubVehicleDialogData;
  const loadervehicle = useSelector((state) => state?.userVehicle?.loading);
  const filterData =  {
    vehicleId: id,
    status:"",
    page:"",
    pageSize:"",
    date:"",
    duration:""
  }

  const vehicleComplianceData = {
    submitterId: id,
    submitterType:"vehicle"
  }

  const vehicleMatrix = {
    vehicleId:id,
  }

  const urlSubVendor = window.location.pathname.includes('subvendor')
  const subVendorBreadcrumbPaths = [
    { name: 'City Manager', url: '/vendor', className:'colorGrey' ,},
    { name: cityLocation, url: '/vendor', className:'colorGrey' ,},
    {name:subVendorName, url: '/vendor',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];
  const vehicleBreadcrumb = [
    {name:'Vehicle', url: '/Vehicle',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];

  const subVendorVehicleBread = [
  { name: 'Sub-Vendor', url: '/subvendor', className:'colorGrey' ,},
  {name:subVendorName, url: '/subvendor',className:'colorGrey'},
  {name:name, url: '',className:'colorBlue'},]

  const breadcrumbPaths =role === 'adminCompany' ?  urlSubVendor ? subVendorBreadcrumbPaths : [
    { name: 'City Manager', url: '/vendor', className:'colorGrey' ,},
    {name:cityLocation, url: '/vendor',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ] :urlSubVendor? subVendorVehicleBread: vehicleBreadcrumb ;

  useEffect(() => {
    dispatch(getVehicle(filterData));
    // dispatch(getMoreVehicle(vehicleComplianceData));
      dispatch(getMatrixVehicle(vehicleMatrix));
  }, []);

  const vehicleInfotable = generateVehicleInfo(vehicleData); 
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleData);

  const onEditProfile = (data, code) => {
    const profileData = {
      vehicleId:id,
      data
    }
    dispatch(patchUpdateVehicle(profileData));
  }

  const handleTabChange = (newValue) => {
    setValue(newValue);
    if (newValue === '1'){
      dispatch(getMatrixVehicle(vehicleMatrix));
    } else if( newValue ==='2'){
      dispatch(getMoreVehicle(vehicleComplianceData));
    } else if (newValue === '3'){
      dispatch(getVehicle(filterData));
      dispatch(getMoreVehicle(vehicleComplianceData));
    }
  }
  
  return (
    <div>
    <CommonBreadCrumb paths={breadcrumbPaths}/>
    <HeaderSubVendor onSubmittBtn={onEditProfile} details={vehicleData} type={'Vehicle'} editData={dialogData(vehicleData)} loader={loadervehicle}/>
    <SubVendorVechileTab
    onTabChange={handleTabChange}
    value={value}
    vehicleImage={vehicleMoreData} vehicleInfo={vehicleInfotable} 
      amenitiesVehicle={vehicleInfoaminities}
      vehicleMoreData={vehicleMoreData}
      vehicleMatrixData={vehicleMatrixData}/>
    </div>
  )
}

export default VechileSubVendorView;